module.exports = __webpack_public_path__ + "img/码垛机器人.5ae60b1a.png";